import { lazy, Suspense } from 'react';
import type { ReactNode } from 'react';
import type { RouteObject } from 'react-router-dom';

import { ProtectedRoute } from '@/auth/ProtectedRoute';
import { RouteErrorBoundary } from '@/components/RouteErrorBoundary';
import { RouteFallback } from '@/components/RouteFallback';

const SecurityPage = lazy(() => import('@/features/settings/security/pages/SecurityPage'));

function withSuspense(node: ReactNode): ReactNode {
  return <Suspense fallback={<RouteFallback />}>{node}</Suspense>;
}

/**
 * Route fragment for the settings feature. Composed into `src/routes.tsx`
 * per docs/web/conventions.md §2.3. Lazy + Suspense + errorElement match the
 * pattern HCP-101 established on the root routes. Multi-tenant scope is
 * enforced server-side via the JWT `tid` claim — the route itself carries no
 * tenant in the path (`/settings/security`, not `/:tenantSlug/settings/...`)
 * because settings act against the operator's already-authenticated tenant
 * context.
 */
export const settingsRoutes: RouteObject[] = [
  {
    path: '/settings/security',
    element: withSuspense(
      <ProtectedRoute>
        <SecurityPage />
      </ProtectedRoute>,
    ),
    errorElement: <RouteErrorBoundary />,
  },
];
